module.exports = __webpack_public_path__ + "img/145.85f86a03.png";